import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';


@Component({
  selector: 'detail-vehicle-images',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="960" title="Fotografías" *ngIf="opened" (close)="onClose()">
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">
        
        <div class="row">
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Marca:"></kendo-label>
                <p class="data-info k-color-info">{{this.form.value.marck}}</p>
            </div>    
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Color:"></kendo-label>
                <p class="data-info k-color-info">{{this.form.value.color}}</p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Placas:"></kendo-label>
                <p class="data-info k-color-info">{{this.form.value.plaque}}</p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Folio de expediente:"></kendo-label>
                <p class="data-info k-color-error right"><b>{{this.form.value.sku_exp}}</b></p>
            </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 example-col">
              <images-scrollview [id]="f.id.value" [height]="'680px'"></images-scrollview> 
          </div>
        </div>
      </div>
    </form>
  </kendo-window>      
  `,
  styles: [``],
  providers: [ DatasourceService ]
})
export class DetailVehicleImagesComponent extends CreateEditWindowComponent {

  @Input() table: string = 'vehicles_inventories';

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);
    
  }

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {    

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),
      'authority_abbreviation': new FormControl((dataItem) ? dataItem.authority_abbreviation: ""),  
      'authority_name': new FormControl((dataItem) ? dataItem.authority_name: ""),  
      'sku_exp': new FormControl((dataItem) ? dataItem.sku_exp: ""),  
      'sku_inv': new FormControl((dataItem) ? dataItem.sku_inv: ""),  
      'vehicle_type_name': new FormControl((dataItem) ? dataItem.vehicle_type_name: ""),  
      'vehicle_type_fee': new FormControl((dataItem) ? dataItem.vehicle_type_fee: ""),  
      'deposit_name': new FormControl((dataItem) ? dataItem.deposit_name: ""),
      'marck': new FormControl((dataItem) ? dataItem.marck: ""),  
      'color': new FormControl((dataItem) ? dataItem.color: ""),  
      'plaque': new FormControl((dataItem) ? dataItem.plaque: ""),
      'serie': new FormControl((dataItem) ? dataItem.serie: ""),
      'entry_date': new FormControl((dataItem) ? this.intl.parseDate(dataItem.entry_date): new Date(), Validators.required),  
      // 'output_date': new FormControl(new Date(), Validators.required),
      'id_person': new FormControl(1, Validators.required), 
      // 'cost_crane': new FormControl((dataItem) ? dataItem.cost_crane: 0),
      'cost_crane': new FormControl(0)
    });    

  };


}
